import { Injectable } from "@angular/core";
import { IID_ISSUE_LINKED } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDIssueLinkedStore } from "./iidIssueLinked.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.ISSUE_LINKED)
export class IIDIssueLinkedQuery extends AbstractInterfaceDataQuery<IID_ISSUE_LINKED> {
  constructor(protected store: IIDIssueLinkedStore) {
    super(store);
  }
}
